import { useForm } from './useForm';
import { FornecedorDetalheSchema } from '../schemas/FornecedorDetalheSchema';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Fornecedor } from '../routes/RoutesNames';
import { useNavigate } from 'react-router-dom';
import { removeSpecialCharacters } from '../shared/utils/helpers/string';
import { getAddressData } from '../services/external/viacep/getCep';
import FornecedorController from '../controllers/FornecedorController';


const useFornecedorCadastro = (fornecedorId?: number | null) => {
  const navigation = useNavigate();
  const [forncedor, setForncedor] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit = async (data: any) => {
    setLoading(true);
    if (fornecedorId) {
      const response = await FornecedorController.Atualizar({
        ...data,
        UsuId: 1,
        FornecedorId: fornecedorId,
      });

      if (response.StatusCode === 204) {
        toast('Fornecedor atualizado com sucesso!', {
          type: 'success',
        });
      }
    } else {
      const response = await FornecedorController.Adicionar({
        ...data,
        UsuId: 1,
      });
      if (response.StatusCode === 204) {
        navigation(Fornecedor);
      }
    }
    setLoading(false);
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: forncedor,
    validationSchema: FornecedorDetalheSchema,
  });

  const backActions = () => {
    navigation(Fornecedor);
  };

  const handleZipCode = async (value: any) => {
    form.handleChange(value);
    const zipcode = value.target.value;

    // @ts-ignore - .
    if (zipcode && removeSpecialCharacters(zipcode).length >= 8) {
      form.handleTextChange('Cep', removeSpecialCharacters(zipcode));
      setLoading(true);
      const response = await getAddressData(zipcode);

      if (response && response.uf) {
        form.handleTextChange('Cidade', response.localidade);
        form.handleTextChange('Estado', response.uf);
        form.handleTextChange('Endereco', response.logradouro);
        form.handleTextChange('Bairro', response.bairro);
      } else {
        form.handleTextChange('Cidade', '');
        form.handleTextChange('Estado', '');
        form.handleTextChange('Endereco', '');
        form.handleTextChange('Bairro', '');
      }
      setLoading(false);
    }
  };

  const getFornecedorById = useCallback(async () => {
    if (!fornecedorId) return;
    try {
      setLoading(true);
      const Response = await FornecedorController.ListarUnico(fornecedorId);
      console.log(Response);
      if (Response.Data) {
        console.log(Response.Data.cli_datanascimento);
        setForncedor({
          Nome: Response.Data.for_nome,
          RazaoSocial: Response.Data.for_razao,
          CpfCnpj: Response.Data.for_cpf_cnpj,
          RgIe: Response.Data.for_rg_ie,
          DataNascimento: Response.Data.for_datanascimento1,
          Nacionalidade: Response.Data.for_nacionalidade,
          Cep: Response.Data.for_cep,
          Cidade: Response.Data.for_cidade,
          Bairro: Response.Data.for_bairro,
          Estado: Response.Data.for_uf,
          Endereco: Response.Data.for_endereco,
          Numero: Response.Data.for_numero,
          Complemento: Response.Data.for_complemento,
          Telefone: Response.Data.for_telefone,
          Celular: Response.Data.for_celular,
          Email: Response.Data.for_email,
          Site: Response.Data.for_website,
        });
      }
    } catch (error) {
      console.error('Error fetching user:', error);
    } finally {
      setLoading(false);
    }
  }, [fornecedorId]);

  useEffect(() => {
    getFornecedorById();
  }, [getFornecedorById]);


  return {
    ...form,
    loading,
    backActions,
    handleZipCode,
  }
}

export default useFornecedorCadastro;